import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["switchInput", "additionalField", "radioSwitch"]

  connect() {
    // Move additional fields next to the switch input in the DOM
    this.additionalFieldTargets.forEach(el => {
      this.switchInputTargets.forEach(switchEl => {
        if (el.dataset.belongsToOption === switchEl.value) {
          (switchEl.closest("span") || switchEl.closest("label")).after(el)
        }
      })
    })

    this.switchInputTargets.forEach(switchEl => {
      // "change" covers select/checkbox/radio; "input" is needed for text/number
      // fields so the additional field reveals immediately as the user types,
      // without waiting for blur.
      switchEl.addEventListener("change", (event) => {
        this.toggleAdditionalField(event.target)
      })
      switchEl.addEventListener("input", (event) => {
        this.toggleAdditionalField(event.target)
      })
    })
    this.radioSwitchTargets.forEach(radioSwitch => {
      radioSwitch.addEventListener("change", (event) => {
        this.toggleRadioSwitch(event.target)
      })
    })
    this.switchInputTargets.forEach(switchEl => {
      this.toggleAdditionalField(switchEl)
    })
  }

  toggleAdditionalField(target) {
    this.additionalFieldTargets.forEach(el => {
      // Selects and text/number inputs are activated by having a non-empty value;
      // checkboxes/radios (handled below) are activated by being checked.
      if (target.type !== "checkbox" && target.type !== "radio") {
        const belongsToOption = el.dataset.belongsToOption
        const isMatchingOption = !belongsToOption || belongsToOption === target.value
        const isActive = !!target.value && isMatchingOption

        if (!isActive) {
          el.value = ""
          el.setAttribute("hidden", "true")
          el.querySelectorAll("input, select, textarea").forEach(input => {
            input.disabled = true
          })
        } else {
          el.removeAttribute("hidden")
          // Remove class hidden
          el.classList.remove("hidden")
          el.querySelectorAll("input, select, textarea").forEach(input => {
            input.disabled = false
          })
        }
        return
      }

      if (el.dataset.belongsToOption && el.dataset.belongsToOption !== target.value) {
        return
      }
      const isActive = target.checked;
      if (!isActive) {
        el.value = ""
        el.setAttribute("hidden", "true")
        el.querySelectorAll("input, select, textarea").forEach(input => {
          input.disabled = true
        })
      } else {
        el.removeAttribute("hidden")
        // Remove class hidden
        el.classList.remove("hidden")
        el.querySelectorAll("input, select, textarea").forEach(input => {
          input.disabled = false
        })
      }
    })
  }

  // For radio buttons we declare targets that will hide the additional fields that do not exist for the selected value
  toggleRadioSwitch(target) {
    this.additionalFieldTargets.forEach(el => {
      if (el.dataset.belongsToOption && el.dataset.belongsToOption !== target.value) {
        el.value = ""
        el.setAttribute("hidden", "true")
        el.querySelectorAll("input, select, textarea").forEach(input => {
          input.disabled = true
        })
      }
    })
  }
}
